export const API_KEY='AIzaSyDshC1CWnnSf92AlC-5w0-o6DLAfQQZs70'
export const RECAPTCHA='6LePxkklAAAAABJyYBkk3EcWGNNlGYjDS63WJDp4'
export const CACHING_TIME=30000
export const DROPBOX_API_KEY='r0aeqq6jb5nhvhr'
// x9e24r3mc77upbe
export const GOOGLE_API_KEY='AIzaSyBcXTjG45zKerY6XarnFwvg0YucCCSmepo'
export const GOOGLE_CLIENT_ID='773635034128-iqiumu7e3736ru19i0cqdbp0un0j2ioq.apps.googleusercontent.com'
export const MICROSOFT_CLIENT_ID='1b3dff25-d868-43ba-b2b4-d2febc37b518'